module.exports = __webpack_public_path__ + "孔剑平-03adeedb.png";